import { mdiArrowLeft, mdiArrowRight } from "@mdi/js";
import Icon from "@mdi/react";
import "../components/orders_mobile.css";
import { FunctionComponent } from "react";
import OrderCreateContext, {
  useOrderCreateCtx,
} from "../../../../context_providers/order_create_context";
import StepperWidget from "../../../new_components/common/stepper_widget";
import BottomSheetWidget from "./bottom_sheet";
import OrderDetailSection from "./order_detail/detail_section";
import ProductSection from "./product/product_section";
import ConsumptionSectionWidget from "./extra_section/extra_section_widget";
import CustomerSectionWidget from "./customer_section/customer_section_widget";

import AttachmentSection from "./attachment/attachment_section";
import CurrencySelector from "./CurrencySelector";
import {
  ToastType,
  useToast,
} from "../../../../context_providers/toast/toast_ctx";
import SubscriptionSection from "../order_detail/subscription/subscription_section";

interface OrderCreatePageProps {}

const OrderCreatePage: FunctionComponent<OrderCreatePageProps> = () => {
  return (
    <>
      <OrderCreateContext>
        <OrderCreateBody />
      </OrderCreateContext>
    </>
  );
};

export default OrderCreatePage;

interface OrderCreateBodyProps {}

const OrderCreateBody: FunctionComponent<OrderCreateBodyProps> = () => {
  const { order, setStep, step, steps } = useOrderCreateCtx();
  const { showToast } = useToast();

  const tryGoNext = () => {
    // Validate Products step (step 2): if any product is Finished Goods, org is mandatory
    if (step === 2) {
      const hasFinishedGoods = (order.products ?? []).some(
        (p) => p?.item?.subcategory === "Finished Goods",
      );
      const orgSet = !!(order as any)?.org?.namespace;
      if (hasFinishedGoods && !orgSet) {
        showToast({
          type: ToastType.error,
          text: "Assigning Organization for Device (Finished Good) is mandatory",
        });
        return;
      }
    }
    setStep(step + 1);
  };

  const getSection = (s: number) => {
    switch (s) {
      case 0:
        return <CustomerSectionWidget />;
      case 1:
        return <OrderDetailSection />;
      case 2:
        return (
          <>
            <CurrencySelector />
            <ProductSection />
          </>
        );
      case 3:
        return (
          <div className="grid grid-cols-1  gap-5">
            <div className="">
              <ConsumptionSectionWidget />
            </div>
          </div>
        );
      case 4:
        return <SubscriptionSection />;
      // case 5:
      //   return <PaymentSectionWidget />;
      case 5:
        return <AttachmentSection />;
      default:
        return <>Not handled</>;
    }
  };
  return (
    <div
      id="order-create-page"
      className="orders-mobile-shrink relative bg-myBgcolor h-screen px-2 md:px-5  overflow-auto"
    >
      <div className="sticky z-10 top-0 p-2  md:px-5 md:pt-3 md:pb-6 rounded-md shadow bg-white mb-3">
        <StepperWidget
          id="order-create-stepper"
          activeStep={step}
          onChange={(s) => {
            setStep(s);
          }}
          steps={steps}
        />
      </div>
      <div
        id={`order-create-step-${step}-section`}
        className="relative"
        style={{ minHeight: "78vh" }}
      >
        {getSection(step)}{" "}
        <div className=" flex items-center justify-between p-5">
          <button
            id="order-create-back-btn"
            onClick={() => setStep(step - 1)}
            className={`${
              step === 0 && "invisible"
            } flex items-center gap-1 px-4 py-2 rounded-md border border-myPrimaryColor text-myPrimaryColor text-sm font-medium hover:bg-myPrimaryColor hover:text-white transition-colors`}
          >
            <Icon path={mdiArrowLeft} className="h-5 w-5"></Icon> Back
          </button>
          <button
            id="order-create-next-btn"
            onClick={tryGoNext}
            className={`${
              step === 6 && "invisible"
            } flex items-center gap-1 px-4 py-2 rounded-md bg-myPrimaryColor text-white text-sm font-medium hover:opacity-90 transition-opacity`}
          >
            Next <Icon path={mdiArrowRight} className="h-5 w-5"></Icon>
          </button>
        </div>
      </div>

      {((order.sale_type === "Transfer order" && order.excessData.length > 0) ||
        order.products.length > 0 ||
        order.services.length > 0 ||
        order.raw_materials.length > 0 ||
        order.discountData.length > 0) && (
        <div className="sticky bottom-0 right-0 mt-3 w-full rounded-t-md bg-white shadow-sm py-3 px-5">
          <BottomSheetWidget />
        </div>
      )}
    </div>
  );
};
